import { createSlice } from '@reduxjs/toolkit';
import { usersApi } from './userApi';
import type { RootState } from '../store';

export interface AuthState {
  acno: string;
  userid: number;
  username: string;
  token: string;
}

const initialState: AuthState = {
  acno: '',
  userid: 0,
  username: '',
  token: ''
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    resetState() {
      return initialState;
    }
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      usersApi.endpoints.signIn.matchFulfilled,
      (state, { payload }) => {
        state.acno = payload.ACNO;
        state.userid = payload.USERID;
        state.username = payload.USERNAME;
        state.token = payload.TOKEN;
      }
    );
  }
});

export default authSlice.reducer;
export const { resetState } = authSlice.actions;

export const selectCurrentUser = (state: RootState) => state.gdata;
